export default function TermsAndConditions() {
  return (
    <main
      className="w-full h-full bg-cover bg-center px-10 pb-10 pt-5 overflow-y-auto bg-white dark:bg-[#0b0c15]"
    >
      <div className="prose mx-auto max-w-4xl dark:prose-invert">
        <h1 className="text-center pb-3 dark:text-white">Terms Of Service</h1>
        <div className=" mx-auto text-gray-800 dark:text-gray-200">
          <h1 className="text-2xl font-bold mb-4">
            Welcome to JNTO!
          </h1>
          <p className="mb-4">
            By downloading, accessing, or using our mobile application ("App"),
            you agree to comply with and be bound by the following Terms and
            Conditions. Please read them carefully.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-2">
            1. Acceptance of Terms
          </h2>
          <p className="mb-4">
            By accessing or using the JNTO App, you agree to be
            legally bound by these Terms. If you do not agree with any part of
            the terms, please do not use the App.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-2">2. Eligibility</h2>
          <p className="mb-4">
            You must be at least 13 years of age to use this App. By using the
            App, you confirm that you meet this requirement.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-2">3. User Account</h2>
          <ul className="list-disc ml-6 mb-4">
            <li>
              You must provide accurate and complete information when creating
              an account.
            </li>
            <li>
              You are responsible for safeguarding your login credentials and
              for all activities under your account.
            </li>
            <li>
              You must notify us immediately of any unauthorized use of your
              account.
            </li>
          </ul>

          <h2 className="text-xl font-semibold mt-6 mb-2">
            4. Privacy and Security
          </h2>
          <p className="mb-4">
            Your privacy is very important to us. All communications on JNTO
            Junto are protected by end-to-end encryption. Our Privacy Policy
            governs how we collect and use your information.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-2">5. User Conduct</h2>
          <p className="mb-2">You agree not to use the App for:</p>
          <ul className="list-disc ml-6 mb-4">
            <li>Illegal or unlawful purposes</li>
            <li>Harassment, abuse, or threats</li>
            <li>Sharing offensive, defamatory, or explicit content</li>
            <li>Impersonating another person</li>
            <li>Spamming or distributing malware</li>
          </ul>
          <p className="mb-4">
            We reserve the right to suspend or terminate your account if you
            violate these rules.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-2">
            6. Intellectual Property
          </h2>
          <p className="mb-4">
            All content, branding, logos, and technology used in the App are the
            property of JNTO or its licensors. You may not use,
            reproduce, or distribute any part of the App without our written
            permission.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-2">
            7. Messaging and Content
          </h2>
          <ul className="list-disc ml-6 mb-4">
            <li>
              Your messages are encrypted and not stored on our servers after
              delivery.
            </li>
            <li>
              You are solely responsible for the content you share via the App.
            </li>
            <li>
              We do not monitor or moderate personal messages unless required by
              law.
            </li>
          </ul>

          <h2 className="text-xl font-semibold mt-6 mb-2">
            8. Updates and Modifications
          </h2>
          <p className="mb-4">
            We may update the App and these Terms from time to time. You will be
            notified of significant changes, and continued use of the App
            constitutes your acceptance of the updated Terms.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-2">
            9. Limitation of Liability
          </h2>
          <p className="mb-2">
            JNTO is provided "as is" and "as available." We make no
            warranties or guarantees of uninterrupted or error-free service. We
            are not liable for any:
          </p>
          <ul className="list-disc ml-6 mb-4">
            <li>Loss of data</li>
            <li>Service disruptions</li>
            <li>Unauthorized access</li>
            <li>Indirect or consequential damages</li>
          </ul>

          <h2 className="text-xl font-semibold mt-6 mb-2">10. Termination</h2>
          <ul className="list-disc ml-6 mb-4">
            <li>
              We may suspend or terminate your access to the App at our
              discretion if you violate these Terms or pose a threat to the
              safety and integrity of the platform.
            </li>
            <li>
              You may terminate your account at any time by deleting the app or
              contacting support.
            </li>
          </ul>

          <h2 className="text-xl font-semibold mt-6 mb-2">11. Contact Us</h2>
          <p className="mb-4">
            For any questions or concerns about these Terms, please contact us
            at: <br />
            <strong>Email:</strong>{" "}
            <a
              href="mailto:tj@textdrip.com"
              className="text-blue-600 underline"
            >
              tj@textdrip.com
            </a>
          </p>
        </div>
      </div>
    </main>
  );
}
